import * as React from 'react';
import { useState } from 'react';
// @ts-ignore
import style from './MessageBubble.module.scss?module';
import { SupportChatAttachment } from './useSupportChatThread';

export default function Attachment({ attachment }: { attachment: SupportChatAttachment }) {
  const [open, setOpen] = useState(false);
  // Override the backend-provided customer_url: we route attachments through
  // the nas-shop proxy so the API key stays server-side.
  const src = `/api/onlineshop/support-chat/attachments/${attachment.id}`;

  return (
    <>
      <button
        type="button"
        className={style.AttachmentThumb}
        onClick={() => setOpen(true)}
        aria-label="Bild vergrößern"
      >
        <img src={src} alt="" loading="lazy" />
      </button>
      {open && (
        <div
          className={style.AttachmentOverlay}
          role="dialog"
          aria-modal="true"
          onClick={() => setOpen(false)}
        >
          <img src={src} alt="" />
        </div>
      )}
    </>
  );
}
